import React from 'react';
import Svg from '../Svg';

const IconHeadphones01 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V18.5C22 20.433 20.433 22 18.5 22C16.567 22 15 20.433 15 18.5V16.5C15 14.567 16.567 13 18.5 13C19.0368 13 19.5454 13.1208 20 13.3368V12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12V13.3368C4.45463 13.1208 4.9632 13 5.5 13C7.433 13 9 14.567 9 16.5V18.5C9 20.433 7.433 22 5.5 22C3.567 22 2 20.433 2 18.5V12ZM4 18.5C4 19.3284 4.67157 20 5.5 20C6.32843 20 7 19.3284 7 18.5V16.5C7 15.6716 6.32843 15 5.5 15C4.67157 15 4 15.6716 4 16.5V18.5ZM20 16.5C20 15.6716 19.3284 15 18.5 15C17.6716 15 17 15.6716 17 16.5V18.5C17 19.3284 17.6716 20 18.5 20C19.3284 20 20 19.3284 20 18.5V16.5Z"
    />
  </Svg>
);

export default IconHeadphones01;
